import { render, staticRenderFns } from "./MyAccount.vue?vue&type=template&id=b98ae6b8&scoped=true&"
import script from "./MyAccount.vue?vue&type=script&lang=js&"
export * from "./MyAccount.vue?vue&type=script&lang=js&"
import style0 from "./MyAccount.vue?vue&type=style&index=0&id=b98ae6b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b98ae6b8",
  null
  
)

export default component.exports